<template>
  <div class="page">
    <v-container fluid>
      <v-responsive max-width="800" class="mx-auto mb-4">
        <v-card class="overflow-y-auto show-on-print" max-height="600">
          <v-card-text
            class="font-weight-bold"
            v-html="termoEmHtml"
          ></v-card-text>
        </v-card>
        <v-container class="px-0" fluid>
          <v-checkbox v-model="checkbox" :disabled="usuario.termoLgpdAceito">
            <template v-slot:label>
              <div>
                Eu {{ $user.fullName }}, CPF Nº {{ $formatCpf($user.username) }},
                concordo com os itens listados do
                <span class="blue--text">
                  Termo de consentimento do uso de dados pessoais.
                </span>
              </div>
            </template>
          </v-checkbox>
        </v-container>
        <v-row class="d-block text-center btn-group">
          <v-col cols="12">
            <v-btn
              v-if="acao.descricao === 'Aceitar' || acao.descricao === 'Ciente'"
              color="primary"
              :disabled="!checkbox"
              @click="aceitarTermo"
            >
              {{ buttonText }}
            </v-btn>
            <v-btn
              v-else-if="acao.descricao === 'Participar/Não Participar'"
              color="primary"
              :disabled="!checkbox"
              @click="aceitarTermo"
            >
              Participar
            </v-btn>
            <v-btn
              v-if="acao.descricao === 'Participar/Não Participar'"
              color="primary"
              outlined
              @click="logout"
            >
              Não Participar
            </v-btn>
          </v-col>
        </v-row>

      </v-responsive>
    </v-container>
  </div>
</template>
  
<script>
  import PageLoadingMixin from "~/mixins/page-loading.mixin";
  import { AUTH_NAMESPACE, USER, LOGIN, UPDATE_ABILITIES, UPDATE_MENU, ABILITIES } from 'store/modules/auth';
  import { convertPermissionsIntoAbilities } from "commons/ability";
  
  export default {
    name: "TermoLGPD",
    computed: {
      user() {
        return this.$store.getters[`${AUTH_NAMESPACE}/${USER}/${LOGIN}`];
      },
      termoEmHtml() {
        return (this.html || '')
          .replaceAll("{{DataAtual}}", this.$dayjs().format('DD/MM/YYYY HH:mm'))
          .replaceAll("{{NomeCompleto}}", this.$user.fullName)
          .replaceAll("{{Cpf}}", this.$formatCpf(this.$user.username))
          .replaceAll("{{Email}}", this.$user.email)
          .replaceAll("{{TelefonePessoal}}", this.$user.call || '-');
      },
      showButton() {
        return this.acao.descricao !== 'Nenhuma Ação';
      }
    },
    mixins: [PageLoadingMixin],
    beforeMount() {
      this.hidePageLoading();
    },
    data: () => ({
      checkbox: false,
      html: "",
      termo: {
        termoId: ``,
        conteudo: ``,
      },
      usuario: {
        cpf: "",
        nome: "",
        vinculos: [],
        termoLgpdAceito: null,
      },
      acao: {
        id: '',
        descricao: ''
      },
      buttonText: ''
    }),
    methods: {
      refreshTokenUi() {
        this.$renovarToken().then(({ data }) => {
          if (data.sucesso) {
            return this[LOGIN](data);
          }
        })
      },
      aceitarTermo() {
        let mensagem = '';
        this.$aceitarTermo({
          cpf: this.$user.username,
          termoId: this.termoId,
          termoAceite: true 
        }).then(({data}) => {
          if(data.sucesso) {
            mensagem = data.mensagem
            return this.refreshTokenUi();
          }
          throw data.mensagem
        }).then(() => {
          return this.$obterMenu(this.$user.username);
        })
        .then(({ data }) => {
          return this[UPDATE_MENU](this.getTransformedMenu(data.itens));
        })
        .then(() => {
          return this.$obterPermissoesDoUsuario(this.$user.username);
        })
        .then(({ data }) => {
          const abilities = convertPermissionsIntoAbilities(data.permissoes);
          this[UPDATE_ABILITIES](abilities);
          return this.updateAbility(abilities);
        }).then(() => {
          return this.$atualizarCacheMenu()
        }).then(() => {
          this.$notifySuccess(mensagem);
          this.$toHome();
        }).catch((error) => {
          this.$notifyError(error.response.data.mensagem);
        });
      },
      updateAbility() {
        return this.$store.getters[`${AUTH_NAMESPACE}/${ABILITIES}`];
      },
      getTransformedMenu(grupos) {
        if (grupos) {
          let menu = [];
          for (let grupo of grupos) {
            let menuItem = {
              icon: grupo.icone,
              name: grupo.nomeDeExibicao,
              url: grupo.endereco,
              items: [],
            };
            if (Array.isArray(grupo.itens)) {
              for (let item of grupo.itens) {
                menuItem.items.push({
                  icon: item.icone,
                  name: item.nomeDeExibicao,
                  url: item.endereco,
                });
              }
              menu.push(menuItem);
            }
          }
          return menu;
        }
        return [];
      },
      async logout() {
        this.$router.push({ path: "/login" });
      },
    },
    mounted() {
      this.$obterTermo({ params: { nomeDoTermo: 'lgpd' } }).then(({ data }) => {
        this.termoId = data.termo.id;
        this.termo = data.termo.nome;
        this.html = data.termo.conteudo;
        this.acao = data.termo.acao;
        const buttonTextMap = {
          'Aceitar': 'Aceitar',
          'Participar/Não Participar': 'Participar/Não Participar',
          'Ciente': 'Ciente'
        };
      this.buttonText = buttonTextMap[this.acao.descricao] || '';
    });
  },
};
</script>